import 'jquery';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap';
import 'admin-lte';
import '@nathanvda/cocoon';
import 'inputmask/dist/jquery.inputmask.min';
import 'icheck-bootstrap';

import bsCustomFileInput from 'bs-custom-file-input';
import formUI from './formUI';
import { imagePreviewer } from './formImagePreviewer';
import tableLink from './tableLink';
import passcodeForm from './passcodeForm';
import studentForm from './studentForm';
import studentCoreSystemObicApi from './studentCoreSystemObicApi';
import studentCoreSystemProfitApi from './studentCoreSystemProfitApi';
import attendanceResultForm from './attendanceResultForm';
import attendanceExportButton from './attendanceExportButton';
import choice from './choice';
import tooltip from './tooltip';
import lessonSlotForm from './lessonSlotForm';
import switchEmailOrPhone from './switchEmailOrPhone';
import disableEmailOrPhone from './disableEmailOrPhone';
import studentLessonForm from './studentLessonForm';
import studentMultiLesson from './studentMultiLesson';
import removeFieldWithErrors from './removeFieldWithErrors';
import switchPracticeExamListbox from './switchPracticeExamListbox';
import confirmPasscodeModal from './confirmPasscodeModal';
import studentConfirmMultipleWatching from './studentConfirmMultipleWatching';
import fileFormMovieDurationAlert from './fileFormMovieDurationAlert';
import bookmarkRecommend from './bookmarkRecommend';

window.addEventListener('DOMContentLoaded', () => {
  formUI();
  tooltip();
  choice();
  imagePreviewer('#student_face_image_file', '#face-image-preview');
  imagePreviewer('#lesson_slot_thumbnail', '#lesson_slot_thumbnail_preview');
  for (let i = 0; i < 3; i++) {
    // 0から3画像まで
    imagePreviewer(`#exam_image${i}`, `#exam_image${i}_preview`);
    imagePreviewer(`#quiz_image${i}`, `#quiz_image${i}_preview`);
  }
  bsCustomFileInput.init();
  tableLink();
  lessonSlotForm();
  passcodeForm();
  studentCoreSystemObicApi();
  studentCoreSystemProfitApi();
  studentForm();
  attendanceResultForm();
  attendanceExportButton();
  switchEmailOrPhone();
  disableEmailOrPhone();
  studentLessonForm();
  studentMultiLesson();
  removeFieldWithErrors();
  switchPracticeExamListbox();
  confirmPasscodeModal();
  studentConfirmMultipleWatching();
  fileFormMovieDurationAlert();
  bookmarkRecommend();
});
